import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getMarkets } from '../../services/marketsService';

export const getMarketsAsync = createAsyncThunk(
  'markets/get',
  async (_, { getState, rejectWithValue }) => {
    const { markets } = getState().markets;
    if (markets.length > 0) return markets;
    try {
      return await getMarkets();
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Failed to fetch markets.');
    }
  },
);

const getMarketsSlice = createSlice({
  name: 'markets',
  initialState: { markets: [], loading: false, error: null },
  extraReducers: (builder) => {
    builder
      .addCase(getMarketsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMarketsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.markets = action.payload.filter((market) => !market.name.startsWith('Kiosk'));
      })
      .addCase(getMarketsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectMarkets = (state) => state.markets.markets;
export const selectMarketsLoading = (state) => state.markets.loading;
export const selectMarketsError = (state) => state.markets.error;
export default getMarketsSlice.reducer;
